'use client'

import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'

export const TopNavV5MobileFooter = () => {
  const trackSelectNavCta = useTrackSelectNavCta()
  const { mobileFooterLinks, mobileDispatch } = useTopNavV5()

  return (
    <footer className="flex flex-col gap-3 border-t border-white/10 p-4 pt-8 text-bodi-gray-butters">
      {mobileFooterLinks
        ?.filter((item) => Boolean(item.title))
        .map((item) => (
          <LocalizedLink
            onClick={() => {
              trackSelectNavCta({ 'cta url': item.href })
              mobileDispatch({ type: 'CLOSE_FROM_MAIN' })
            }}
            key={item?.title}
            href={item.href ?? ''}
            rel={item.newTab ? 'noopener noreferrer' : ''}
            target={item.newTab ? '_blank' : '_self'}
          >
            {item.title}
          </LocalizedLink>
        ))}
    </footer>
  )
}
